export default __webpack_public_path__ + "static/media/137_graffurious_kawai0001.6bca7cd4.png";